import React, { useEffect, useState } from "react";
import { FaEdit, FaTrashAlt, FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { IoMdDownload } from "react-icons/io";
import InvoiceModal from "../components/InvoiceModal";
import Tag from "./Tag";
import {
	getInvoicesBySeller,
	getInvoicesByTag,
	deleteInvoice as deleteInvoiceServer,
	updateInvoice,
	searchInvoices,
} from "../services/invoicesService";
import { getTags, getTagsById } from "../services/tagService";
import { getSellerById } from "../services/sellerService";
import Loading from "./Loading";

const InvoicesTable = ({
	mode,
	invoices,
	setError,
	tagId,
	sellerId,
	setInvoices,
	auth,
	setSumImport,
	setSuccess,
	setTitle,
	searchParams,
}) => {
	// mode = "seller" || "tag" || "search"
	const [tags, setTags] = useState(null);
	const [loading, setLoading] = useState(false);

	// Modale
	const [editingInvoice, setEditingInvoice] = useState(null);
	const [deleteInvoice, setDeleteInvoice] = useState(null);

	//Paginzione
	// const [totalInvoices, setTotalInvoices] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const LIMIT = process.env.REACT_APP_LIMIT_PAGINATION || 20;

	useEffect(() => {
		setLoading(true);
		setError(null);

		if (mode === "tag") {
			Promise.all([
				getInvoicesByTag(auth, tagId, currentPage, LIMIT),
				getTags(auth),
				getTagsById(auth, tagId),
			])
				.then(([{ count, invoices, sum }, tags, tag]) => {
					setTags(tags);
					setInvoices(invoices);
					setSumImport(Number(sum));
					// setTotalInvoices(count);
					setTotalPages(Math.ceil(count / LIMIT));
					setTitle(`Fatture con tag '${tag.tag}'`);
					const newData = invoices.map((invoice) => {
						if (invoice.tag_ids) {
							const tagIds = invoice.tag_ids.split(",").map((id) => parseInt(id));
							invoice.tags = tags.filter((tag) => tagIds.includes(tag.id));
						} else invoice.tags = [];
						return invoice;
					});
					setInvoices(newData);
				})
				.catch((err) => setError("Errore nel caricamento delle fatture per tag."))
				.finally(() => setLoading(false));
		} else if (mode === "seller") {
			Promise.all([
				getInvoicesBySeller(auth, sellerId, currentPage, LIMIT),
				tags || getTags(auth),
				getSellerById(auth, sellerId),
			])
				.then(([{ count, invoices }, tags, seller]) => {
					setTags(tags);
					// setTotalInvoices(count);
					setTotalPages(Math.ceil(count / LIMIT));
					setTitle(`Fatture di ${seller.name}`);
					const newData = invoices.map((invoice) => {
						if (invoice.tag_ids) {
							const tagIds = invoice.tag_ids.split(",").map((id) => parseInt(id));
							invoice.tags = tags.filter((tag) => tagIds.includes(tag.id));
						} else invoice.tags = [];
						return invoice;
					});
					setInvoices(newData);
				})
				.catch((err) => setError("Errore nel caricamento delle fatture per venditore."))
				.finally(() => setLoading(false));
		} else if (mode === "search") {
			if (
				!searchParams ||
				(searchParams.descr === "" &&
					searchParams.startDate === "" &&
					searchParams.endDate === "" &&
					(!searchParams.excludedTagIds || searchParams.excludedTagIds.length === 0))
			) {
				setInvoices(null);
				setLoading(false);
				// setTotalInvoices(0);
				setCurrentPage(1);
			} else
				Promise.all([
					searchInvoices(
						auth,
						searchParams.descr,
						searchParams.startDate,
						searchParams.endDate,
						currentPage,
						LIMIT,
						searchParams.excludedTagIds || []
					),
					getTags(auth),
				])
					.then(([{ invoices, count }, tags]) => {
						setTags(tags);
						// setTotalInvoices(count);
						setTotalPages(Math.ceil(count / LIMIT));
						const newData = invoices.map((invoice) => {
							if (invoice.tag_ids) {
								const tagIds = invoice.tag_ids.split(",").map((id) => parseInt(id));
								invoice.tags = tags.filter((tag) => tagIds.includes(tag.id));
							} else invoice.tags = [];
							return invoice;
						});
						setInvoices(newData);
					})
					.catch((err) => setError("Errore nel caricamento delle fatture"))
					.finally(() => setLoading(false));
		} else {
			setError("Parametro di ricerca dati non specificato");
			setLoading(false);
		}
	}, [currentPage, searchParams]);

	const handlePageChange = (page) => {
		setError(null);
		setSuccess(null);
		if (page < 1 || page > totalPages) return;
		setCurrentPage(page);
	};

	const handleDownloadInvoice = (id) => {
		if (!id) {
			setError("Errore nel download della fattura.");
			return;
		}
		const token = auth.token;

		const viewerUrl = `${
			process.env.REACT_APP_API_URL
		}invoices/${id}/pdf?token=${encodeURIComponent(token)}`;

		window.open(viewerUrl, "_blank");
	};

	const handleEditInvoice = (invoice) => {
		setSuccess(null);
		setError(null);
		setEditingInvoice(invoice);
	};

	const handleSaveEdit = (newInvoice) => {
		setSuccess(null);
		setError(null);
		let tags_id = newInvoice.tags.map((tag) => tag.id).join(",");

		updateInvoice(
			auth,
			newInvoice.id,
			newInvoice.date,
			newInvoice.descr,
			newInvoice.importo,
			tags_id
		)
			.then(() => {
				const updatedInvoices = invoices.map((invoice) =>
					editingInvoice.id === invoice.id ? newInvoice : invoice
				);
				setInvoices(updatedInvoices);
				setEditingInvoice(null);
				setSuccess("Fattura aggiornata con successo.");
			})
			.catch(setError);
	};

	const handleDeleteInvoice = (invoiceId) => {
		setSuccess(null);
		setError(null);
		deleteInvoiceServer(auth, invoiceId)
			.then(() => {
				const updatedInvoices = invoices.filter((invoice) => invoice.id !== invoiceId);
				setInvoices(updatedInvoices);
				setSuccess("Fattura eliminata con successo.");
			})
			.catch(setError)
			.finally(() => setDeleteInvoice(null));
	};

	const handleCancelDelete = () => setDeleteInvoice(null);

	if (loading) return <Loading />;

	return (
		<div>
			<div className="table-container">
				<table className="table is-fullwidth is-hoverable">
					<thead>
						<tr>
							<th className="has-text-centered">Data</th>
							<th className="has-text-centered">Descrizione</th>
							<th className="has-text-centered">Importo</th>
							{(mode === "tag" || mode === "search") && (
								<th className="has-text-centered">Venditore</th>
							)}
							{(mode === "seller" || mode === "search") && (
								<th className="has-text-centered">Tag</th>
							)}
							<th className="has-text-centered">Azioni</th>
						</tr>
					</thead>
					<tbody>
						{invoices ? (
							invoices.map((invoice) => (
								<tr key={invoice.id}>
									<td className="is-vcentered">
										{invoice.date.substring(0, 10)}
									</td>
									<td className="is-vcentered">{invoice.descr}</td>
									<td className="has-text-right is-vcentered">
										{Number(invoice.importo).toLocaleString("it-IT", {
											style: "currency",
											currency: "EUR",
										})}
									</td>
									{(mode === "tag" || mode === "search") && (
										<td className="has-text-centered is-vcentered">
											{invoice.seller_name}
										</td>
									)}
									{(mode === "seller" || mode === "search") && (
										<td className="has-text-centered is-vcentered">
											{invoice.tags.length > 0 ? (
												invoice.tags.map((tag) => (
													<div key={tag.id}>
														<Tag
															text={tag.tag}
															hex_color={tag.hex_color}
															id={tag.id}
														/>
													</div>
												))
											) : (
												<em>nessun tag</em>
											)}
										</td>
									)}
									<td className="is-vcentered has-text-centered">
										{invoice.justUploaded !== null &&
											invoice.justUploaded !== true && (
												<button
													className="button is-outlined is-info is-small mr-1"
													onClick={() =>
														handleDownloadInvoice(invoice.id)
													}
												>
													<IoMdDownload />
												</button>
											)}
										<button
											className="button is-outlined is-primary is-small mx-1"
											onClick={() => handleEditInvoice(invoice)}
										>
											<FaEdit />
										</button>
										{mode !== "search" && (
											<button
												className="button is-outlined is-danger is-small ml-1"
												onClick={() => setDeleteInvoice(invoice)}
											>
												<FaTrashAlt />
											</button>
										)}
									</td>
								</tr>
							))
						) : (
							<tr>
								<td
									colSpan={mode === "search" ? 6 : 5}
									className="has-text-centered"
								>
									<em>nessuna fattura trovata</em>
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{/* Modal per la modifica */}
			{editingInvoice && (
				<InvoiceModal
					invoice={editingInvoice}
					onClose={() => setEditingInvoice(null)}
					onSave={handleSaveEdit}
					tags={tags.filter((tag) => tag.hidden === 0)}
				/>
			)}

			{/* Modal di conferma eliminazione */}
			{deleteInvoice && (
				<div className="modal is-active">
					<div className="modal-background" onClick={handleCancelDelete}></div>
					<div className="modal-content">
						<div className="box">
							<h2 className="subtitle">Conferma Eliminazione</h2>
							<p>Sei sicuro di voler eliminare questa fattura?</p>
							<div className="control has-text-right">
								<button
									className="button is-secondary mr-2"
									onClick={handleCancelDelete}
								>
									Annulla
								</button>
								<button
									className="button is-danger"
									onClick={() => handleDeleteInvoice(deleteInvoice.id)}
								>
									Elimina
								</button>
							</div>
						</div>
					</div>
					<button className="modal-close is-large" onClick={handleCancelDelete}></button>
				</div>
			)}

			{/* Paginazione */}
			<div className="pagination is-centered">
				<button
					className="pagination-previous"
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage <= 1}
				>
					<FaArrowLeft />
				</button>
				<button
					className="pagination-next"
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage >= totalPages}
				>
					<FaArrowRight />
				</button>
				<ul className="pagination-list">
					{Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
						<li key={page}>
							<button
								className={`pagination-link ${
									page === currentPage ? "is-current" : ""
								}`}
								onClick={() => handlePageChange(page)}
							>
								{page}
							</button>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default InvoicesTable;
